import { useFormik } from "formik";
import { Avatar, Button, TextInput, theme, Typography } from "kosmos-ui/lib";

import { useShopper } from "app/context/ShopperContext/hooks";
import { useLayout } from "app/context/LayoutContext/hooks";
import { useUpdateMyShopperProfileMutation } from "api/graphql/mutations/shopper/hooks";
import {
  ShopperBrowserSection,
  GroupedInputsContainer,
  ShopperBrowserForm,
} from "../../styles";

import { TUpdateMyShopperProfileFormValues } from "./types";
import { ShopperAvatarContainer } from "./styles";

export default function ShopperProfileSection() {
  const { mobile } = useLayout();

  const { shopper } = useShopper();

  const [
    updateMyShopperProfileMutation,
    { loading: loadingUpdateMyShopperProfileMutation },
  ] = useUpdateMyShopperProfileMutation();

  const form = useFormik<TUpdateMyShopperProfileFormValues>({
    initialValues: {
      firstname: shopper?.firstname,
      lastname: shopper?.lastname,
      rut: shopper?.rut || "",
      phone: shopper?.phone || "",
      locationAddress:
        (shopper?.locations &&
          shopper.locations.length > 0 &&
          shopper.locations[0].address) ||
        "",
    },
    onSubmit({ locationAddress, ...values }) {
      updateMyShopperProfileMutation({
        variables: {
          ...values,
          locations: [
            {
              city: "",
              commune: "",
              address: locationAddress,
            },
          ],
        },
      });
    },
  });

  return (
    <ShopperBrowserSection style={{ maxWidth: 380 }}>
      <ShopperAvatarContainer>
        <Avatar
          withInitials
          height={mobile ? 40 : 64}
          style={{ marginBottom: 12 }}
        >
          {shopper?.firstname} {shopper?.lastname}
        </Avatar>

        <Typography
          as="h1"
          variant="title3"
          style={{ margin: 0, color: theme.colorsPalette.white.default }}
        >
          {shopper?.firstname} {shopper?.lastname}
        </Typography>

        <Typography
          as="p"
          variant="paragraph2"
          style={{
            color: theme.colorsPalette.gray.lighter,
            margin: "8px 0 16px 0",
          }}
        >
          {shopper?.email}
        </Typography>
      </ShopperAvatarContainer>

      <ShopperBrowserForm onSubmit={form.handleSubmit} noValidate>
        <GroupedInputsContainer>
          <TextInput
            name="firstname"
            value={form.values.firstname}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            label="Nombre"
            variant="filled"
            style={{
              root: { marginRight: 16 },
              inputContainer: {
                backgroundColor: theme.colorsPalette.black.lighter,
                border: "none",
              },
            }}
          />

          <TextInput
            name="lastname"
            value={form.values.lastname}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            label="Apellido"
            variant="filled"
            style={{
              inputContainer: {
                backgroundColor: theme.colorsPalette.black.lighter,
                border: "none",
              },
            }}
          />
        </GroupedInputsContainer>

        <GroupedInputsContainer>
          <TextInput
            name="rut"
            value={form.values.rut}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            label="RUT"
            variant="filled"
            style={{
              root: { marginRight: 16 },
              inputContainer: {
                backgroundColor: theme.colorsPalette.black.lighter,
                border: "none",
              },
            }}
          />

          <TextInput
            name="phone"
            value={form.values.phone}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            label="Teléfono"
            variant="filled"
            style={{
              inputContainer: {
                backgroundColor: theme.colorsPalette.black.lighter,
                border: "none",
              },
            }}
          />
        </GroupedInputsContainer>

        <TextInput
          name="locationAddress"
          value={form.values.locationAddress}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          label="Dirección"
          variant="filled"
          style={{
            inputContainer: {
              backgroundColor: theme.colorsPalette.black.lighter,
              border: "none",
            },
          }}
        />

        <Button
          variant="primary"
          type="submit"
          loading={loadingUpdateMyShopperProfileMutation}
          style={{ width: "100%", marginTop: 24 }}
        >
          Guardar cambios
        </Button>
      </ShopperBrowserForm>
    </ShopperBrowserSection>
  );
}
